import { useEffect, useState } from "react";
import { doc } from "firebase/firestore";
import { useDocument } from "react-firebase-hooks/firestore";
import { db } from "@poseidon/firebase/firebase";
import { dealerRiskProfileSchema } from "../schema";

export const useDealerRiskProfile = ({ dealerId }) => {
  const [dealerRiskProfile, setDealerRiskProfile] = useState();
  const [value, loading, error] = useDocument(
    doc(db, "dealerRiskProfiles", dealerId),
    {
      snapshotListenOptions: { includeMetadataChanges: true },
    }
  );
  useEffect(() => {
    if (value) {
      const dealer = mapDealerRiskProfile(value);
      setDealerRiskProfile(dealer);
    }
  }, [value, dealerId]);

  return { dealerRiskProfile, loading, error };
};

const mapDealerRiskProfile = (docRef) => {
  if (!docRef.exists()) {
    return {};
  }

  let dealerRiskProfile = dealerRiskProfileSchema.cast(docRef.data());
  dealerRiskProfile.id = docRef.id;

  return dealerRiskProfile;
};
